import { render, staticRenderFns } from "./NumberQuiz.vue?vue&type=template&id=dd998bb8&scoped=true&lang=pug&"
import script from "./NumberQuiz.vue?vue&type=script&lang=js&"
export * from "./NumberQuiz.vue?vue&type=script&lang=js&"
import style0 from "./NumberQuiz.vue?vue&type=style&index=0&id=dd998bb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd998bb8",
  null
  
)

component.options.__file = "NumberQuiz.vue"
export default component.exports